import Comunity from "../../components/Comunity/Comunity";
import { PublicLayout } from "../../components/Layout/PublicLayout";
const breadcrumbsData = [
  {
    label: "Inicio",
    path: "/",
  },
  {
    label: "Comunidad",
    path: "/comunidad",
  },
];
const ComunityPage = () => {
  return (
    <PublicLayout breadcrumb={breadcrumbsData} breadcrumbTitle='Comunidad'>
      <Comunity />
    </PublicLayout>
  );
};

export default ComunityPage;
